import { render } from "./logout-button.vue?vue&type=template&id=5132d35a"
import script from "./logout-button.vue?vue&type=script&lang=js"
export * from "./logout-button.vue?vue&type=script&lang=js"
script.render = render

export default script